<template>
	<sym-icon v-if="visible" :name="iconName" :class="clazz" :style="style"></sym-icon>
</template>

<script setup lang="ts">
import SymIcon from "../helpers/SymIcon.vue";
import usePart, {type PartProps, partProps} from "../Part";
// import type {Icon} from "@t/fd/fixed/Icon";
// import {computed} from "vue";

const uprops = defineProps({...partProps});
const props = uprops as PartProps;

//const i = computed<Icon>(() => props.part as Icon);
const {visible, valueExpression, clazz, style} = usePart(props);

const iconName = valueExpression("value", "ex");
</script>

<style>
</style>